import getHostName from "util/get-host-name";

export default function makeNumbersPretty(brandId) {
  return `
    <script>
      !function(d,o,j,O,mo,jo){'crl8'in d||(d.crl8=function(){d.crl8.q.push(arguments);},d.crl8.q=[]),mo=o.createElement(j),mo.src=O,mo.onload=function(){DOJOMOJO.send();},mo.async=!0,jo=o.getElementsByTagName(j)[0],jo.parentNode.insertBefore(mo,jo);}(window,document,'script','${getHostName()}/track.js?brand_id=${brandId}');
    </script>
  `;
}
